var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M399 384.2C376.9 345.8 335.4 320 288 320H224C176.6 320 135.1 345.8 113 384.2C148.2 423.4 199.2 448 256 448C312.8 448 363.8 423.3 399 384.2ZM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256ZM256 272C295.8 272 328 239.8 328 200C328 160.2 295.8 128 256 128C216.2 128 184 160.2 184 200C184 239.8 216.2 272 256 272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActiveIcon);
export default __webpack_public_path__ + "static/media/profile-active-icon.6a45ce28ebcb1128b5777d8c246035e6.svg";
export { ForwardRef as ReactComponent };